import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";
import { ActionStatusEnum, ActionTypeEnum } from "@/domain/action.enum";

const validationSchema = (t: TFunction) => {
  return yup.object().shape({
    name: yup
      .string()
      .required(t("validations.required"))
      .min(2, t("validations.min_length", { count: 2 }))
      .max(100, t("validations.max_length", { count: 100 })),
    code: yup
      .string()
      .required(t("validations.required"))
      .max(100, t("validations.max_length", { count: 100 })),
    description: yup
      .string()
      .required(t("validations.required"))
      .max(500, t("validations.max_length", { count: 500 })),
    type: yup
      .string()
      .required(t("validations.required"))
      .oneOf(Object.values(ActionTypeEnum), t("validations.invalid_format")),
    status: yup
      .string()
      .required(t("validations.required"))
      .oneOf(Object.values(ActionStatusEnum), t("validations.invalid_format")),
    link: yup
      .string()
      .optional()
      .max(255, t("validations.max_length", { count: 255 })),
    order: yup
      .number()
      .optional()
      .min(0, t("validations.min_value", { count: 0 })),
    icon: yup
      .string()
      .optional()
      .max(100, t("validations.max_length", { count: 100 })),
    subActions: yup.array().of(yup.string()).optional(),
  });
};

export type ActionFormData = InferType<ReturnType<typeof validationSchema>>;

export default validationSchema;
